module.exports = __webpack_public_path__ + "static/img/chailv.a461d3ab.png";